<template>
  <NuxtLoadingIndicator color="#297FFF" />
  <NuxtLayout>
    <LazyModalsCampaign hydrate-on-idle />
    <LazyModalsCTA hydrate-on-idle />
    <LazyModalsImagePreview hydrate-on-idle />
    <NuxtPage />
  </NuxtLayout>
</template>